import {
  initializeApp
} from 'firebase';

const app = initializeApp({
  apiKey: "AIzaSyC_rxSOZBqCFQ8-8XFa7A0k8b8-l_xlbOM",
  authDomain: "greenland-aa0a0.firebaseapp.com",
  databaseURL: "https://greenland-aa0a0.firebaseio.com",
  projectId: "greenland-aa0a0",
  storageBucket: "greenland-aa0a0.appspot.com",
  messagingSenderId: "452219633362"
});

export const db = app.database();
export default db



// WEBPACK FOOTER //
// ./src/firebase.js